import { Component, Input, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { EthWalletService } from 'src/app/services/eth-wallet.service';
import { MessageService } from 'src/app/services/message.service';
import { RouterService } from 'src/app/services/router.service';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {
  @Input() address: string;
  @Input() category: string;
  @Input() note: string;

  constructor(
    public ethWalletService: EthWalletService,
    private accountService: AccountService,
    private routerService: RouterService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
  }

  onClick() {
    this.messageService.success('Copied to clipboard.');
  }

  observe() {
    this.accountService.setObserveAddress(this.address);
    this.routerService.navigate(['/main']);
  }

  get icon() {
    switch (this.category) {
      case 'company':
        return 'fa-building text-warning';
      case 'team':
        return 'fa-user text-warning';;
      default:
        return 'fa-user text-success';;
    }
  }
}
